import { createCustomIcon } from "components/primitives";

import { ReactComponent as Icon_Add_svg } from "./Icon_Add.svg";
import { ReactComponent as Icon_AddEmoji_svg } from "./Icon_AddEmoji.svg";
import { ReactComponent as Icon_AddImage_svg } from "./Icon_AddImage.svg";
import { ReactComponent as Icon_ArrowPoint_Down_svg } from "./Icon_ArrowPoint_Down.svg";
import { ReactComponent as Icon_ArrowPoint_Left_svg } from "./Icon_ArrowPoint_Left.svg";
import { ReactComponent as Icon_ArrowPoint_Right_svg } from "./Icon_ArrowPoint_Right.svg";
import { ReactComponent as Icon_ArrowPoint_Up_svg } from "./Icon_ArrowPoint_Up.svg";
import { ReactComponent as Icon_CantSee_svg } from "./Icon_CantSee.svg";
import { ReactComponent as Icon_Close_svg } from "./Icon_Close.svg";
import { ReactComponent as Icon_Collapse_Left_svg } from "./Icon_Collapse_Left.svg";
import { ReactComponent as Icon_Collapse_Right_svg } from "./Icon_Collapse_Right.svg";
import { ReactComponent as Icon_Copy_svg } from "./Icon_Copy.svg";
import { ReactComponent as Icon_Dashboard_svg } from "./Icon_Dashboard.svg";
import { ReactComponent as Icon_Delete_svg } from "./Icon_Delete.svg";
import { ReactComponent as Icon_Drag_svg } from "./Icon_Drag.svg";
import { ReactComponent as Icon_External_svg } from "./Icon_External.svg";
import { ReactComponent as Icon_Eye_Close_svg } from "./Icon_eye_close.svg";
import { ReactComponent as Icon_Featured_svg } from "./Icon_Featured.svg";
import { ReactComponent as Icon_Fullscreen_svg } from "./Icon_Fullscreen.svg";
import { ReactComponent as Group_svg } from "./Icon_Group.svg";
import { ReactComponent as Icon_Heart_Filled_svg } from "./Icon_Heart_Filled.svg";
import { ReactComponent as Icon_Heart_Outline_svg } from "./Icon_Heart_Outline.svg";
import { ReactComponent as Icon_Line_svg } from "./Icon_Line.svg";
import { ReactComponent as Icon_List_svg } from "./Icon_List.svg";
import { ReactComponent as Icon_Loading_svg } from "./Icon_Loading.svg";
import { ReactComponent as Icon_Move_svg } from "./Icon_Move.svg";
import { ReactComponent as Icon_Move_Orange_svg } from "./Icon_Move_orange.svg";
import { ReactComponent as Icon_Next_svg } from "./Icon_Next.svg";
import { ReactComponent as Icon_NumberLine_Add_svg } from "./Icon_NumberLine_Add.svg";
import { ReactComponent as Icon_NumberLine_Box_One_svg } from "./Icon_NumberLine_Box_One.svg";
import { ReactComponent as Icon_NumberLine_Box_QuestionMark_svg } from "./Icon_NumberLine_Box_QuestionMark.svg";
import { ReactComponent as Icon_NumberLine_One_svg } from "./Icon_NumberLine_One.svg";
import { ReactComponent as Icon_NumberLine_QuestionMark_svg } from "./Icon_NumberLine_QuestionMark.svg";
import { ReactComponent as Icon_Paint_Bucket_svg } from "./Icon_Paint_Bucket.svg";
import { ReactComponent as Icon_Pause_svg } from "./Icon_Pause.svg";
import { ReactComponent as Icon_Pencil_svg } from "./Icon_Pencil.svg";
import { ReactComponent as Icon_Pencil_Modified_svg } from "./Icon_Pencil_Modified.svg";
import { ReactComponent as Icon_Play_svg } from "./Icon_Play.svg";
import { ReactComponent as Icon_PlayPet_svg } from "./Icon_PlayPet.svg";
import { ReactComponent as Icon_Randomize_svg } from "./Icon_Randomize.svg";
import { ReactComponent as Icon_Remove_svg } from "./Icon_Remove.svg";
import { ReactComponent as Icon_Reset_svg } from "./Icon_Reset.svg";
import { ReactComponent as Icon_Roll_svg } from "./Icon_Roll.svg";
import { ReactComponent as Icon_Save_svg } from "./Icon_Save.svg";
import { ReactComponent as Icon_See_svg } from "./Icon_See.svg";
import { ReactComponent as Icon_Spin_svg } from "./Icon_Spin.svg";
import { ReactComponent as Icon_Stop_svg } from "./Icon_Stop.svg";
import { ReactComponent as Icon_TextToSpeech_svg } from "./Icon_TextToSpeech.svg";
import { ReactComponent as Icon_Tick_svg } from "./Icon_Tick.svg";
import { ReactComponent as Icon_Volume_Off_svg } from "./Icon_Volume_Off.svg";
import { ReactComponent as Icon_Volume_On_svg } from "./Icon_Volume_On.svg";
import { ReactComponent as Icon_Widget_Expand_svg } from "./Icon_Widget_Expand.svg";
import { ReactComponent as Icon_Widget_MoreOptions_svg } from "./Icon_Widget_MoreOptions.svg";
import { ReactComponent as Icon_Widget_Settings_svg } from "./Icon_Widget_Settings.svg";
import { ReactComponent as Icon_Widget_Spotlight_svg } from "./Icon_Widget_Spotlight.svg";
import { ReactComponent as Icon_XY_svg } from "./Icon_XY.svg";
export const Add = createCustomIcon(Icon_Add_svg, "Add");
export const AddEmoji = createCustomIcon(Icon_AddEmoji_svg, "AddEmoji");
export const AddImage = createCustomIcon(Icon_AddImage_svg, "AddImage");
export const ArrowPointDown = createCustomIcon(Icon_ArrowPoint_Down_svg, "ArrowPoint_Down");
export const ArrowPointLeft = createCustomIcon(Icon_ArrowPoint_Left_svg, "ArrowPoint_Left");
export const ArrowPointRight = createCustomIcon(Icon_ArrowPoint_Right_svg, "ArrowPoint_Right");
export const ArrowPointUp = createCustomIcon(Icon_ArrowPoint_Up_svg, "ArrowPoint_Up");
export const CantSee = createCustomIcon(Icon_CantSee_svg, "CantSee");
export const Close = createCustomIcon(Icon_Close_svg, "Close");
export const CollapseLeft = createCustomIcon(Icon_Collapse_Left_svg, "Collapse_Left");
export const CollapseRight = createCustomIcon(Icon_Collapse_Right_svg, "Collapse_Right");
export const Dashboard = createCustomIcon(Icon_Dashboard_svg, "Dashboard");
export const Delete = createCustomIcon(Icon_Delete_svg, "Delete");
export const External = createCustomIcon(Icon_External_svg, "External");
export const Featured = createCustomIcon(Icon_Featured_svg, "Featured");
export const Fullscreen = createCustomIcon(Icon_Fullscreen_svg, "Fullscreen");
export const HeartFilled = createCustomIcon(Icon_Heart_Filled_svg, "Heart_Filled");
export const HeartOutline = createCustomIcon(Icon_Heart_Outline_svg, "Heart_Outline");
export const List = createCustomIcon(Icon_List_svg, "List");
export const Move = createCustomIcon(Icon_Move_svg, "Move");
export const Next = createCustomIcon(Icon_Next_svg, "Next");
export const NumberLineAdd = createCustomIcon(Icon_NumberLine_Add_svg, "NumberLine_Add");
export const NumberLineBoxOne = createCustomIcon(Icon_NumberLine_Box_One_svg, "NumberLine_Box_One");
export const NumberLineBoxQuestionMark = createCustomIcon(
  Icon_NumberLine_Box_QuestionMark_svg,
  "NumberLine_Box_QuestionMark",
);
export const NumberLineOne = createCustomIcon(Icon_NumberLine_One_svg, "NumberLine_One");
export const NumberLineQuestionMark = createCustomIcon(
  Icon_NumberLine_QuestionMark_svg,
  "NumberLine_QuestionMark",
);
export const Pause = createCustomIcon(Icon_Pause_svg, "Pause");
export const Play = createCustomIcon(Icon_Play_svg, "Play");
export const PlayPet = createCustomIcon(Icon_PlayPet_svg, "PlayPet");
export const Randomize = createCustomIcon(Icon_Randomize_svg, "Randomize");
export const Remove = createCustomIcon(Icon_Remove_svg, "Remove");
export const Reset = createCustomIcon(Icon_Reset_svg, "Reset");
export const Roll = createCustomIcon(Icon_Roll_svg, "Roll");
export const Save = createCustomIcon(Icon_Save_svg, "Save");
export const See = createCustomIcon(Icon_See_svg, "See");
export const eyeClose = createCustomIcon(Icon_Eye_Close_svg, "EyeClose");
export const Spin = createCustomIcon(Icon_Spin_svg, "Spin");
export const Stop = createCustomIcon(Icon_Stop_svg, "Stop");
export const TextToSpeech = createCustomIcon(Icon_TextToSpeech_svg, "TextToSpeech");
export const Tick = createCustomIcon(Icon_Tick_svg, "Tick");
export const VolumeOff = createCustomIcon(Icon_Volume_Off_svg, "Volume_Off");
export const VolumeOn = createCustomIcon(Icon_Volume_On_svg, "Volume_On");
export const WidgetExpand = createCustomIcon(Icon_Widget_Expand_svg, "Widget_Expand");
export const WidgetMoreOptions = createCustomIcon(
  Icon_Widget_MoreOptions_svg,
  "Widget_MoreOptions",
);
export const WidgetSettings = createCustomIcon(Icon_Widget_Settings_svg, "Widget_Settings");
export const WidgetSpotlight = createCustomIcon(Icon_Widget_Spotlight_svg, "Widget_Spotlight");
export const XY = createCustomIcon(Icon_XY_svg, "XY");
export const PaintBucket = createCustomIcon(Icon_Paint_Bucket_svg, "Paint Bucket");
export const Copy = createCustomIcon(Icon_Copy_svg, "Copy");
export const Drag = createCustomIcon(Icon_Drag_svg, "Drag");
export const Loading = createCustomIcon(Icon_Loading_svg, "Loading");
export const Pencil = createCustomIcon(Icon_Pencil_svg, "Pencil");
export const PencilForWidget = createCustomIcon(Icon_Pencil_Modified_svg, "Pencil");
export const LineIcon = createCustomIcon(Icon_Line_svg, "Line");
export const MoveWithOrangeColor = createCustomIcon(Icon_Move_Orange_svg, "Move");
export const GroupIcon = createCustomIcon(Group_svg, "Group");
